// const HighlightData = [
//     // {
//     //     id: 1,
//     //     title: "CAPTIV SOFTWARE AND WIRELESS SENSORS",
//     //     description: "World leader in human measurement in complex and real environments for over 30 years, TEA innovates for the well-being of humans with agile solutions and services.",
//     //     cover: "https://www.eyemotion.in/wp-content/uploads/2021/02/Tea-banner-1.jpg",
//     //     brand: "https://acrm.org/wp-content/uploads/2021/03/logo-bertec-1.png",
//     // },
//     {
//         id: 1,

//         cover: require("../../Assets/Banner/banner-image-ergonomics1.jpg"),
//     },


// ]

// export default HighlightData

const HighlightData = [
    {
        id: 1,
        cover: require("../../Assets/Banner/todaybanner.jpg"),

    },
    {
        id: 2,
        cover: require("../../Assets/CategoryPage/Sports Biomechanics.jpg"),

    }
    ,
    {
        id: 3,
        cover: require("../../Assets/CategoryPage/Sports Strength.webp"),

    }
    ,
    {
        id: 4,


        cover: require("../../Assets/Products/Physiology/moxymonitor.jpg"),

    }
    ,
    {
        id: 5,

        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),

    }
    ,
    {
        id: 6,

        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),

    }
    ,
    {
        id: 7,

        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),

    }
    ,
    {
        id: 8,

        cover: require("../../Assets/CategoryPage/Exercise & Sports Physiology.jpg"),

    }

]

export default HighlightData